import JavaOverrideServerProperties from "../../../../contents/docs/integrate/feature-flags-code/_snippets/override-server-properties/java.mdx";
import * as React from 'react';
export default {
  JavaOverrideServerProperties,
  React
};